import { render, staticRenderFns } from "./qushi.vue?vue&type=template&id=2a10f954&scoped=true&"
import script from "./qushi.vue?vue&type=script&lang=js&"
export * from "./qushi.vue?vue&type=script&lang=js&"
import style0 from "./qushi.vue?vue&type=style&index=0&id=2a10f954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a10f954",
  null
  
)

export default component.exports